
import {
    CategoryIsMandatory,
     ProductsListInputParam, SBL_BuilderPage,
    SBL_BuilderPageMain,
    SBL_BuilderPagePreset,
    SBL_BuilderPageProduct_Product
} from "../interfaces";
import {cloneDeep} from "lodash";
import {rootActions} from "../DAL/store";

import {LocalEnums} from "../local-enums";
import {getSblCost} from "../DAL/data-service";

export const IsProductInclude = (product:SBL_BuilderPageMain, selectedProducts:SBL_BuilderPageMain[]) => {
    let found = false;
    for(let i = 0; i < selectedProducts.length; i++) {
        if (selectedProducts[i].categoryProductID === product.categoryProductID) {
            found = true;
        }
    }
    return found;
}
export const GetProductIndex = (product:SBL_BuilderPageMain, selectedProducts:SBL_BuilderPageMain[]) => {
    let index = -1;
    for(let i = 0; i < selectedProducts.length; i++) {
        if (selectedProducts[i].skuid === product.skuid) {
            index = i;
        }
    }
    return index;
}
export const OnProductClickChangeState = async(categoryProducts: SBL_BuilderPageMain[],
                                           categoryId: number,
                                           userState_SystemType :string,
                                           userState_SelectedProducts:SBL_BuilderPageMain[],
                                           builderPageProduct_Product : SBL_BuilderPageProduct_Product[],
                                           productList:SBL_BuilderPageMain[],
                                           builderPage:SBL_BuilderPage,
                                           dispatch : any
                                           ) => {
    let systemType = userState_SystemType;
    // --------   if in not custom system:   ------
            // set custom system on step 1
    if( userState_SystemType !== "c" ){
        systemType ="c";
    }


    let newSelectedProducts = cloneDeep(userState_SelectedProducts);
    // remove all old presertProducts
    newSelectedProducts = newSelectedProducts.filter(product => product.categoryID !== categoryId);
    //add new categoryProducts to all selectedProducts
    newSelectedProducts = categoryProducts.concat(newSelectedProducts);
    // get the hidden product only by categoryProducts
    let hiddenProductsByLastChange = GetHiddenProducts(newSelectedProducts,builderPageProduct_Product,productList);
    // remove all hidden product by last change
    newSelectedProducts = newSelectedProducts.filter(product => hiddenProductsByLastChange.includes(product.categoryProductID) === false);

    //if the product is from the category - Software, add cable to the system if is not exists already
    if( categoryProducts.length === 1 && categoryProducts[0].categoryID === LocalEnums.CategoriesIds.Software ){
        let cableProduct = newSelectedProducts.filter(product => product.categoryProductID === LocalEnums.ProductsIds.Cable);
        if(cableProduct.length === 0){
            let cable = cloneDeep(productList.filter(product => product.categoryProductID === LocalEnums.ProductsIds.Cable)[0]);
            newSelectedProducts.push(cable);
        }
    }

    // get the hidden product by all selectedProducts
    let hiddenProducts = GetHiddenProducts(newSelectedProducts,builderPageProduct_Product,productList);


    //set UserState_CategoriesIsMandatory
    let CategoriesIsMandatory = GetMandatoryCategoriesBySelectedProducts(newSelectedProducts,builderPage);

    //remove all selected product that it's category is hidden
    newSelectedProducts = GetOnlyVisibleProducts(newSelectedProducts,CategoriesIsMandatory);
    //set isAllMandatoryAdded for -Buy From A Dealer- button view
    let isAllMandatoryAdded = IsAllMandatoryAdded(CategoriesIsMandatory,newSelectedProducts);

    /// set new cabel value
    let cableCount = GetCableCount(newSelectedProducts);

    //Set UserState_NumberOfInputs
    //https://wavesaudio.atlassian.net/browse/DSWEB-1021
    let numberOfInputs = GetCurrentNumberOfInputs(newSelectedProducts);

    let totalCost = 0;
    if(newSelectedProducts.length > 0){
        dispatch(
            rootActions.main({
                UserState_CostLoading:true
            })
        );
        let productsListInputParams = GetProductsListInputParams(newSelectedProducts,cableCount);
        const response = await getSblCost(productsListInputParams);
        if(!response || response.statusCode !== 200 || !response.data.relatedData) return;
        totalCost = response.data.relatedData.subtotal;
    }

    dispatch(
        rootActions.main({
            UserState_SoftwareWasChosen: true,
            UserState_HiddenProductIds: hiddenProducts,
            UserState_CableCount: cableCount,
            UserState_CategoriesIsMandatory:CategoriesIsMandatory,
            UserState_SelectedProducts:newSelectedProducts,
            UserState_SystemType:systemType,
            UserState_AllMandatoryAdded:isAllMandatoryAdded,
            UserState_Cost:totalCost,
            UserState_NumberOfInputs:numberOfInputs,
            ProductList:productList,
            UserState_CostLoading:false
        })
    );

    UpdateUrlParam(systemType,newSelectedProducts,cableCount);

    // update url params
}
const GetCurrentNumberOfInputs = (newSelectedProducts:SBL_BuilderPageMain[]) => {
    let numberOfInputs = 0;
    newSelectedProducts.forEach(prod => {
        if(prod.numberOfInputs > 0){
            numberOfInputs += (prod.numberOfInputs * prod.quantity);
        }
    });
    return numberOfInputs;
}
const GetOnlyVisibleProducts = (newSelectedProducts:SBL_BuilderPageMain[],userState_CategoriesIsMandatory:CategoryIsMandatory[]) => {
    let selectedProduct = [] as SBL_BuilderPageMain[];
    newSelectedProducts.forEach(product => {
        let productsToRemove = userState_CategoriesIsMandatory.filter(category => category.isHidden && product.categoryID === category.categoryID);
        if(productsToRemove.length === 0){
            selectedProduct.push(product);
        }
    })
    return selectedProduct;
}
export const UpdateUrlParam = (systemType:string,newSelectedProducts:SBL_BuilderPageMain[],cableQuantity:number) => {
    let relativeLocation = "#" + systemType;
    if(systemType.includes("c")){
        newSelectedProducts.forEach(prod => {
            let quantity = 1;
            if(prod.categoryProductID === LocalEnums.ProductsIds.Cable){
                quantity = cableQuantity;
            }
            else if(prod.quantity){
                quantity = prod.quantity;
            }
            relativeLocation = relativeLocation + "|" + prod.categoryProductID + "-" + quantity;
        })
    }
    window.location.replace(relativeLocation);

}
const GetMandatoryCategoriesBySelectedProducts = (selectedProducts: SBL_BuilderPageMain[],builderPage:SBL_BuilderPage) => {
    let CategoriesIsMandatory = [] as CategoryIsMandatory[];
    builderPage.sbl_BuilderPageCategory_ProductList.forEach(item => {
        let categoryIsMandatory = {} as CategoryIsMandatory;
        categoryIsMandatory.categoryID = item.categoryID;
        categoryIsMandatory.categoryOrder = builderPage.sbl_BuilderPageMainList.filter(itm => itm.categoryID === item.categoryID)[0].categoryOrder;

        if(item.selectedCategoryProductID === null || item.selectedCategoryProductID === 0){
            //if item.selectedCategoryProductID in null show category
            categoryIsMandatory.isHidden = false;
            categoryIsMandatory.isMandatory = item.isMandatory;

        }else{
            // if item.selectedCategoryProductID in not null:
            //get all items of the current category
            //look for item with selectedCategoryProductID that exists in user's selected product
            //item with match selectedCategoryProductID exists? show category, else -> hide it.
            categoryIsMandatory.isHidden = true;
            let categoryProductList = builderPage.sbl_BuilderPageCategory_ProductList.filter(currItem => currItem.categoryID === categoryIsMandatory.categoryID);
            categoryProductList.forEach(categoryProduct => {
                let categoryProducts = selectedProducts.filter(product => product.categoryProductID === categoryProduct.selectedCategoryProductID);
                if(categoryProducts.length > 0){
                    categoryIsMandatory.isHidden = false;
                    categoryIsMandatory.isMandatory = categoryProduct.isMandatory;
                }

            })
        }
        if(CategoriesIsMandatory.filter(category => category.categoryID === categoryIsMandatory.categoryID).length === 0){
            CategoriesIsMandatory.push(categoryIsMandatory);
        }
    });
    return CategoriesIsMandatory
}
export const GetCableCount = (selectedProducts : SBL_BuilderPageMain[]) => {
    let count = 0;
    selectedProducts.forEach(product => {
        if(product.cableLogic === LocalEnums.CableLogic.productNeedCable){
            let quantity = product.quantity ? product.quantity : 1;
            count+= quantity;
        }
    })
    return count;
}
export const OnSystemTypeClickChangeState = async(selectedSystemType:any,
                                              userState_SystemType :string,
                                              builderPagePresetList:SBL_BuilderPagePreset[],
                                              products : SBL_BuilderPageMain[],
                                              builderPage:SBL_BuilderPage,
                                              dispatch : any) => {
    //systemType options:
    //"c" : custom
    //p-3 : presetId 3
    //p-5 : presetId 5
    //...

    if(selectedSystemType === userState_SystemType){
        // if is the same system    -> do nothing
        return;
    }
    let selectedProducts = [] as SBL_BuilderPageMain[];
    // if custom ->  set only UserState_SystemType & clear UserState_Selected
    if(selectedSystemType !== "c" && selectedSystemType.includes("-")){
        let pair = selectedSystemType.split('-');
        if(pair.length === 2){
            selectedProducts = GetSelectedValuesBySystemType(+pair[1],builderPagePresetList,products);
        }
    }
    //on load, set allProducts quantities by selectedProducts quantities
    let updatedAllProducts = GetAllProductsWithQuantityBySelectedProductQuantity(products,selectedProducts);

    // get the hidden product by all selectedProducts
    let hiddenProducts = GetHiddenProducts(selectedProducts,builderPage.sbl_BuilderPageProduct_ProductList,products);


    //set UserState_CategoriesIsMandatory
    let CategoriesIsMandatory = GetMandatoryCategoriesBySelectedProducts(selectedProducts,builderPage);

    /// set new cable value
    let cableCount = GetCableCount(selectedProducts);
    selectedProducts = SetCoubleCountInProducts(selectedProducts, cableCount);

    let totalCost = 0;
    if(selectedProducts.length > 0){
        dispatch(
            rootActions.main({
                UserState_CostLoading:true
            })
        );
        let productsListInputParams = GetProductsListInputParams(selectedProducts,cableCount);
        const response = await getSblCost(productsListInputParams);
        if(!response || response.statusCode !== 200 || !response.data.relatedData) return;
        totalCost = response.data.relatedData.subtotal;
    }


    dispatch(
        rootActions.main({
            UserState_CategoriesIsMandatory:CategoriesIsMandatory,
            UserState_SoftwareWasChosen:selectedProducts.length > 0,
            UserState_SystemType: selectedSystemType,
            UserState_CableCount: cableCount,
            ProductList:updatedAllProducts,
            UserState_SelectedProducts: selectedProducts,
            UserState_HiddenProductIds:hiddenProducts,
            //systemType is not custom -> all the mandatory product is set/
            //systemType is custom -> clears all product selection
            UserState_AllMandatoryAdded:selectedSystemType !== "c",
            UserState_Cost:totalCost,
            UserState_CostLoading:false
        })
    );

    UpdateUrlParam(selectedSystemType,selectedProducts,cableCount);

}
const SetCoubleCountInProducts = (products : SBL_BuilderPageMain[], cableCount : number) => {
    products.forEach(prod => {
        if(prod.categoryProductID === LocalEnums.ProductsIds.Cable){
            prod.quantity = cableCount;
        }
    })
    return products;
}
export const GetSelectedValuesBySystemType = (presetId:number,
                                              builderPagePresetList:SBL_BuilderPagePreset[],
                                              products : SBL_BuilderPageMain[]
                                                ) => {
    let selectedProducts = [] as SBL_BuilderPageMain[];
    builderPagePresetList.filter(pre => pre.presetID === presetId).forEach(preset => {
        let product = products.filter(product => product.categoryProductID === preset.categoryProductID)
        if(product.length > 0){
            let prestProduct = cloneDeep(product[0]);
            prestProduct.quantity = 1;
            selectedProducts.push(prestProduct);
        }
    });
    return selectedProducts;
}

//Get all products with updated quantities by selected products quantities
const GetAllProductsWithQuantityBySelectedProductQuantity = (allProducts : SBL_BuilderPageMain[],selectedProducts : SBL_BuilderPageMain[]) => {
    let updatedAllProducts = cloneDeep(allProducts);
    updatedAllProducts.map(prod => {
        let selected = selectedProducts.filter(selectedProduct => selectedProduct.categoryProductID === prod.categoryProductID);
        if(selected.length === 1){
            prod.quantity = selected[0].quantity;
        }
        else
            prod.quantity =1;
        return prod;
    });
    return updatedAllProducts;
}
export const InitUserState = async (CategoryList:SBL_BuilderPageMain[],
                                  builderPageProduct_Product : SBL_BuilderPageProduct_Product[],
                                  products : SBL_BuilderPageMain[],
                                    builderPagePresetList:SBL_BuilderPagePreset[],
                                    builderPage:SBL_BuilderPage,
                                    dispatch : any) => {
    let systemType = GetSystemTypeByUrl(window.location.hash);

    let selectedProducts = GetSelectedProductByUrl(window.location.hash,products,builderPagePresetList);

    //on load, set allProducts quantities by selectedProducts quantities
    let updatedAllProducts = GetAllProductsWithQuantityBySelectedProductQuantity(products,selectedProducts);

    //set UserState_CategoriesIsMandatory
    let categoriesIsMandatory = GetMandatoryCategoriesBySelectedProducts(selectedProducts,builderPage);

    let hiddenProducts = GetHiddenProducts(selectedProducts,builderPageProduct_Product,products);
    /// set new cable value
    let cableCount = GetCableCount(selectedProducts);
    selectedProducts = SetCoubleCountInProducts(selectedProducts, cableCount);

    //set isAllMandatoryAdded for -Buy From A Dealer- button view
    let isAllMandatoryAdded = IsAllMandatoryAdded(categoriesIsMandatory,selectedProducts);

    //Set UserState_NumberOfInputs
    //https://wavesaudio.atlassian.net/browse/DSWEB-1021
    let numberOfInputs = GetCurrentNumberOfInputs(selectedProducts);

    let totalCost = 0;
    if(selectedProducts.length > 0){
        let productsListInputParams = GetProductsListInputParams(selectedProducts , cableCount);
        const response = await getSblCost(productsListInputParams);
        if(!response || response.statusCode !== 200 || !response.data.relatedData) return;
        totalCost = response.data.relatedData.subtotal;
    }

    dispatch(
        rootActions.main({
            UserState_SoftwareWasChosen: selectedProducts.length > 0,
            UserState_SystemType: systemType,
            UserState_SelectedProducts: selectedProducts,
            UserState_HiddenProductIds: hiddenProducts,
            UserState_CategoriesIsMandatory:categoriesIsMandatory,
            UserState_CableCount: cableCount,
            ProductList:updatedAllProducts,
            //systemType is not custom -> all the mandatory product is set/
            //systemType is custom -> clears all product selection
            UserState_AllMandatoryAdded:isAllMandatoryAdded,
            UserState_Cost:totalCost,
            UserState_NumberOfInputs:numberOfInputs,
            PageWasLoad:true
        })
    );

}
export const GetProductsListInputParams = (selectedProducts: SBL_BuilderPageMain[],cableCount : number) => {
    let productListInputParams = [] as ProductsListInputParam[];
    selectedProducts.forEach(prod => {
        let productListInputParam = {} as ProductsListInputParam;
        productListInputParam.productID = prod.categoryProductID
        productListInputParam.sKUID = prod.skuid;
        productListInputParam.sKUName = prod.skuName;
        if(prod.categoryProductID === LocalEnums.ProductsIds.Cable){
            productListInputParam.quantity = cableCount;
        }else{
            productListInputParam.quantity = prod.quantity? prod.quantity : 1;
        }
        productListInputParams.push(productListInputParam);
    })
    return productListInputParams;

}
export const GetHiddenProducts = (userState_SelectedProducts: SBL_BuilderPageMain[],
                           builderPageProduct_Product : SBL_BuilderPageProduct_Product[],
                           products : SBL_BuilderPageMain[]) => {

    let userState_HiddenProductsIds  = [] as number[];
    builderPageProduct_Product.filter(prod1 => prod1.selectedCategoryProductID !== null && prod1.selectedCategoryProductID !== 0)
        .forEach(prod2 => {
            //for each item that it's SelectedCategoryProductID is not null -> get all items with the same ProductCategoryID
            let products = builderPageProduct_Product.filter(prod => prod.productCategoryID === prod2.productCategoryID);
            let isVisible = false;
            //check if one of the userState_SelectedProducts is included in products(SelectedCategoryProductID)
            products.forEach(prod3 => {
                let currentSelected = userState_SelectedProducts.filter(prod => prod.categoryProductID === prod3.selectedCategoryProductID );
                if(currentSelected.length > 0){
                    isVisible = true;
                }
            })
            if(!isVisible){
                userState_HiddenProductsIds.push(prod2.productCategoryID);
            }
        });
    //https://wavesaudio.atlassian.net/browse/DSWEB-1023
    //when user selects more than one stagebox or stagebox with qty>1
    //hide and de-select all switches from the switches category except the one switch where IsMultiStageBoxSwitch = 1
    let multiStageBoxSelected = MultiStageBoxWereSelected(userState_SelectedProducts);
    if(multiStageBoxSelected){
        //hide all products of Category.StageBoxes where IsMultiStageBoxSwitch === false
        let nonMultiStage = products.filter(product => {
            return product.categoryID === LocalEnums.CategoriesIds.NetworkSwitches && !product.isMultiStageBoxSwitch;
        });
        nonMultiStage.forEach(product => {
            if(!userState_HiddenProductsIds.includes(product.categoryProductID)){
                userState_HiddenProductsIds.push(product.categoryProductID);
            }
        })
    }

    return userState_HiddenProductsIds;
}

/**
 * @param userState_SelectedProducts
 * https://wavesaudio.atlassian.net/browse/DSWEB-1023
 *
 * when user selects more than one stagebox or stagebox with qty>1 -->
 * hide and de-select all switches from the switches category except the one switch where IsMultiStageBoxSwitch = 1
 *
 * This method return true when :  user selects more than one stagebox or stagebox with qty>1
 * Otherwise returns false
 */
const MultiStageBoxWereSelected = (userState_SelectedProducts: SBL_BuilderPageMain[]) => {
    let isMulti = false;
    let stageBoxes = userState_SelectedProducts.filter(product => product.categoryID === LocalEnums.CategoriesIds.StageBoxes);
    if(stageBoxes.length > 1){
        isMulti = true;
    }else if(stageBoxes.length === 1 && stageBoxes[0].quantity > 1){
        isMulti = true;
    }
    return isMulti;
}
const GetSystemTypeByUrl = (url:string) => {
    let tempUrlParts = url.split('#');

    let paramsUrlPart = tempUrlParts[1];
    let systemType = "";
    if(paramsUrlPart){
        systemType = paramsUrlPart.split('|')[0];
    }
    return systemType;

}
const GetSelectedProductByUrl = (url:string, products:SBL_BuilderPageMain[],builderPagePresetList:SBL_BuilderPagePreset[]) : SBL_BuilderPageMain[] => {
    if(url.length === 0){
        return [] as SBL_BuilderPageMain[];
    }

    let tempUrlParts = url.split('#');

    let paramsUrlPart = tempUrlParts[1];
    let selectedProducts = [] as SBL_BuilderPageMain[];

    let params = paramsUrlPart.split('|');

    let systemType = GetSystemTypeByUrl(url);

    if(systemType.includes("p-")){
        let pair = systemType.split('-');
        selectedProducts = GetSelectedValuesBySystemType(+pair[1],builderPagePresetList,products);

    }else{
        for(let i = 1; i < params.length; i++ ){
            let pair = params[i].split('-');
            if(pair.length === 2){
                let selectedProduct = cloneDeep(products.filter(prod => prod.categoryProductID === +pair[0])[0]);
                selectedProduct.quantity = +pair[1];
                selectedProducts.push(selectedProduct);
            }
        }
    }


    return selectedProducts;

}
export const GetIsCategoryIsMandatory = (UserState_CategoriesIsMandatory:CategoryIsMandatory[] , categoryId : number) => {
    let isMandatory = false;
    UserState_CategoriesIsMandatory.forEach(categoryIsMandatory => {
        if(categoryIsMandatory.categoryID === categoryId){
            isMandatory = categoryIsMandatory.isMandatory;
        }
    })
    return isMandatory;
}
const IsAllMandatoryAdded = (userState_CategoriesIsMandatory:CategoryIsMandatory[]
                            ,userState_SelectedProducts: SBL_BuilderPageMain[]) => {

    let missingMandatoryCategoryFound = userState_CategoriesIsMandatory.some(category => {

        if(category.isMandatory){

            let isMandatoryAdded = false;
            userState_SelectedProducts.forEach(product => {
                if(product.categoryID === category.categoryID){
                    isMandatoryAdded = true;
                }
            });
            //if for this category no product was added -> return false
            if(!isMandatoryAdded){
                return true;
            }
        }
        return false;
    });
    return !missingMandatoryCategoryFound;
}
export const GetCurrentlyAddedMandatoryLine = (userState_SelectedProducts: SBL_BuilderPageMain[],userState_CategoriesIsMandatory:CategoryIsMandatory[]) =>{
    //(Currently added: 1/3 mandatory items)
    //get is software seleted
    // get num of selected & mandatory
    // get num of mandatory
    let mandatoryNumber = userState_CategoriesIsMandatory.filter(category => category.isMandatory).length;
    let mandatorySelected = 0;
    userState_CategoriesIsMandatory.forEach(category => {
        if(category.isMandatory){
            let selectedItems = userState_SelectedProducts.filter(prod => prod.categoryID === category.categoryID);
            if(selectedItems.length > 0){
                mandatorySelected++;
            }
        }
    });
    return `(Currently added: ${mandatorySelected + "/" + mandatoryNumber} mandatory items)`;
}
export const ResetChart = (dispatch : any,builderPage:SBL_BuilderPage) =>{

    dispatch(
        rootActions.main({
            UserState_SoftwareWasChosen:false,
            UserState_SystemType: "",
            UserState_SelectedProducts: [] as SBL_BuilderPageMain[],
            UserState_HiddenProductIds: [] as number[],
            UserState_CategoriesIsMandatory:GetMandatoryCategoriesBySelectedProducts([] as SBL_BuilderPageMain[],builderPage),
            UserState_CableCount: 0,
            UserState_AllMandatoryAdded:false,
            UserState_Cost:0
        })
    );
    window.history.replaceState({}, '', document.location.pathname+ document.location.search);
}